import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { X } from "lucide-react";

const DISMISS_KEY = "gh_promo_dismissed";
const RETURNING_DISMISS_KEY = "gh_loyalty_dismissed";
const PREFILL_KEY = "gh_promo_prefill";
const ORDERED_KEY = "gh_has_ordered";

export const PromoBanner = () => {
  const [show, setShow] = useState(false);
  const [returning, setReturning] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const hasOrdered = !!localStorage.getItem(ORDERED_KEY);
    setReturning(hasOrdered);
    const dismissKey = hasOrdered ? RETURNING_DISMISS_KEY : DISMISS_KEY;
    if (!localStorage.getItem(dismissKey)) setShow(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(returning ? RETURNING_DISMISS_KEY : DISMISS_KEY, "1");
    setShow(false);
  };

  const copyCode = (code) => {
    navigator.clipboard?.writeText(code);
    toast.success(`Code ${code} copied 💛`);
  };

  const beginJourney = () => {
    localStorage.setItem(PREFILL_KEY, "WELCOME11");
    nav("/cart");
  };

  const beginThankYou = () => {
    localStorage.setItem(PREFILL_KEY, "THANKYOU");
    nav("/cart");
  };

  if (!show) return null;

  return (
    <div data-testid="promo-banner" className="relative bg-[#3A3632] text-[#FAF7F2]">
      <div className="max-w-6xl mx-auto px-10 sm:px-12 py-2.5 flex items-center justify-center gap-2 text-center text-xs sm:text-sm">
        {returning ? (
          <>
            <span className="font-hand text-[#E7C9C9] text-base sm:text-lg">Welcome back —</span>
            <span>Use code</span>
            <button
              data-testid="loyalty-banner-code"
              onClick={() => copyCode("THANKYOU")}
              className="font-semibold tracking-wider border border-dashed border-[#C4A4A4] rounded px-2 py-0.5 hover:bg-[#C4A4A4]/15 transition-colors"
            >
              THANKYOU
            </button>
            <span>to receive a complimentary surprise with your next purchase.</span>
            <button
              onClick={beginThankYou}
              data-testid="loyalty-banner-shop"
              className="hidden sm:inline underline underline-offset-2 hover:text-[#E7C9C9] transition-colors"
            >
              Shop now
            </button>
          </>
        ) : (
          <>
            <span className="font-hand text-[#E7C9C9] text-base sm:text-lg">Welcome —</span>
            <span>Enjoy</span>
            <button
              data-testid="promo-banner-code"
              onClick={() => copyCode("WELCOME11")}
              className="font-semibold tracking-wider border border-dashed border-[#C4A4A4] rounded px-2 py-0.5 hover:bg-[#C4A4A4]/15 transition-colors"
            >
              WELCOME11
            </button>
            <span>for <strong>11% off</strong> your first order.</span>
            <button
              onClick={beginJourney}
              data-testid="promo-banner-shop"
              className="hidden sm:inline underline underline-offset-2 hover:text-[#E7C9C9] transition-colors"
            >
              Begin Your Journey
            </button>
          </>
        )}
      </div>
      <button
        onClick={dismiss}
        data-testid="promo-banner-close"
        aria-label="Dismiss"
        className="absolute top-1/2 -translate-y-1/2 right-3 p-1 rounded-full hover:bg-white/10 transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
